import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  header: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '10px 15px 5px',
    backgroundColor: theme.colors.dark.darkSlateBlue,
  },
  headerTop: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  zone: {
    marginRight: 10,
    padding: '9px 14px',
    fontSize: 12,
    color: theme.colors.orange.orange,
    backgroundColor: theme.colors.orange.orangeSemiTransparent,
    borderRadius: 50,
  },
  tableNumberBlock: {
    display: 'flex',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tableNumber: {
    minWidth: 36,
    margin: '0 3px',
    textAlign: 'center',
  },
  invoiceNumber: {
    margin: '0 5px',
  },
  createdTimeAgo: {
    minWidth: 45,
    marginRight: 10,
    fontWeight: 500,
    color: theme.colors.red,
  },
  iconWrapper: {
    '@media(max-width: 400px)': {
      display: 'none',
    },
  },
  // Auxiliary classes
  overflowText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  flexAlignedCenter: {
    display: 'flex',
    alignItems: 'center',
  },
}));
